import React from "react";
import LojaModel from "./model/LojaModel";
import AppState from "./model/AppState";
import { FormControl, Snackbar } from "@material-ui/core";
import ObaTextField from "./components/ObaTextField";
import InputMask from "react-input-mask";
import CarrinhoModel from "./model/CarrinhoModel";
import C5PagamentoModel, {
  C5PagamentoDetalhesModel,
} from "./model/C5PagamentoModel";
import C5PagamentoDAO from "./dataAccess/C5/C5PagamentoDAO";
import NavegadorUtil from "./util/NavegadorUtil";
import AgendamentoRetiradaModel from "./model/AgendamentoRetiradaModel";
import { CartaoCreditoClearsaleEnum, CartaoCreditoEnum } from "./model/CartaoCreditoModel";
import AlertaModel from "./model/AlertaModel";
import C5MeioPagamentoModel from "./model/C5MeioPagamentoModel";
import BotaoVoltar from "./components/BotaoVoltar";
import LogUtil from "./util/LogUtil";
import UsuarioModel from "./model/UsuarioModel";
import { RouteComponentProps, withRouter } from "react-router-dom";
import ProxyCacheDAO from "./dataAccess/Proxy/ProxyCacheDados";
import ProxyEsqueciSenhaDAO from "./dataAccess/Proxy/ProxyEsqueciSenha";
import { CieloAddress, CieloCreditCard, CieloCustomer, CieloPagamentoModel } from "./model/CieloPagamentoModel";
import UsuarioEnderecoModel from "./model/UsuarioEnderecoModel";
import C5UsuarioDAO from "./dataAccess/C5/C5UsuarioDAO";
import ProxyPagamentoDAO from "./dataAccess/Proxy/ProxyPagamentoDAO";
import DataUtil from "./util/DataUtil";
import { ClearsaleBillingModel, ClearsaleCardModel, ClearsaleEnderecoModel, ClearsaleItemModel, ClearsalePagamentoItemModel,
  ClearsalePagamentoModel, ClearsaleShippingModel, ClearsaleTelefoneModel } from "./model/ClearsalePagamentoModel";
import * as publicIp from "public-ip";
import ObaPedidoDAO from "./dataAccess/Oba/ObaPedidoDAO";
import ProxyPromocaoDAO from "./dataAccess/Proxy/ProxyPromocaoDAO";
import { ObaTipoPromocaoEnum } from "./model/ObaPromocaoModel";

interface IFormaPagamentoProps extends RouteComponentProps {}

type FormaPagamentoState = {
  tipoPagamento: string;
  numeroCartao: string;
  nomeCartao: string;
  cpfTitular: string;
  validade: string;
  codigoSeguranca: string;
  bandeiraCartao: string;
  bandeiraCartaoClearsale: CartaoCreditoClearsaleEnum;
  imagemCartao: string;
  pagamentoSucesso: boolean;
  meiosPagamento: C5MeioPagamentoModel[];
  pagando: boolean;
  descontoExtra: number;
  debitoHabilitado: boolean;
  creditoHabilitado: boolean;
  formaPagamento?: FormaPagamentoEnum;
  formasPagamento: FormaPagamentoEnum[];
};

enum FormaPagamentoEnum {
  PAGAMENTO_ONLINE = 1,
  PAGAMENTO_NA_RETIRADA = 2,
}

enum CampoFormularioEnum {
  TIPO_PAGAMENTO = 1,
  NUMERO_CARTAO,
  NOME_CARTAO,
  CPF_TITULAR,
  VALIDADE,
  CODIGO_SEGURANCA,
}

class FormaPagamento extends React.Component<
  IFormaPagamentoProps,
  FormaPagamentoState
> {
  constructor(props: IFormaPagamentoProps) {
    super(props);

    this.setValue = this.setValue.bind(this);
    this.pagar = this.pagar.bind(this);
    this.getPaymentId = this.getPaymentId.bind(this);
    this.getCartaoIcone = this.getCartaoIcone.bind(this);
    this.setCartao = this.setCartao.bind(this);
    this.validarCartaoBandeira = this.validarCartaoBandeira.bind(this);
    this.setPagamentoRetirada = this.setPagamentoRetirada.bind(this);
    this.setPagamentoOnline = this.setPagamentoOnline.bind(this);

    this.state = {
      tipoPagamento: "",
      numeroCartao: "",
      nomeCartao: "",
      cpfTitular: "",
      validade: "",
      codigoSeguranca: "",
      bandeiraCartao: "",
      imagemCartao: "",
      pagamentoSucesso: false,
      meiosPagamento: [],
      descontoExtra: 0,
      pagando: false,
      debitoHabilitado: false,
      creditoHabilitado: false,
      bandeiraCartaoClearsale: CartaoCreditoClearsaleEnum.OUTROS,
      formasPagamento: [],
    };
  }

  async componentDidMount(): Promise<void> {
    LogUtil.logPage("Forma de pagamento");

    const loja = AppState.getLojaSelecionada();
    const carrinho = AppState.getCarrinho();
    const lojasPgtoOnline: any[] = [ 
      "1", "2", "3", "5", "6", "9", "10", "11", "12", "13", "14", "15", "16", "17", "19", "21", "23", "24", "25", 
      "26", "29", "30", "32", "34", "35", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48", 
      "50", "51", "52", "53", "54", "55", "56", "59", "61", "62", "63", "64", "69", "71", "91", "100", "108", "120" ];

    this.setState({
      formasPagamento: [ FormaPagamentoEnum.PAGAMENTO_NA_RETIRADA ],
      formaPagamento: FormaPagamentoEnum.PAGAMENTO_NA_RETIRADA
    });

    if (carrinho && loja) {
      if (lojasPgtoOnline.some(l => loja.lojaIdOba === l)) {
        this.setState({
          formasPagamento: [ FormaPagamentoEnum.PAGAMENTO_ONLINE ],
          formaPagamento: FormaPagamentoEnum.PAGAMENTO_ONLINE
        });
      }

      ProxyPromocaoDAO.getInstance().getPromocoes(loja).then((listaPromocoesFF: any) => {
        for (const promo of listaPromocoesFF) {
          if (promo.de <= new Date() && promo.ate >= new Date() && promo.tipo === ObaTipoPromocaoEnum.COMPRE_X_PAGUE_Y) {
            if (promo.lojas.some((l: any) => l.lojaId === loja.lojaId)) {
              for (const carrinhoItem of carrinho.carrinhoItens) {
                const prod = promo.produtos.find((p: any) => p.produtoId === carrinhoItem.produto.produtoId);
                if (prod) {
                  const qtdDescontos = Math.floor(carrinhoItem.quantidade / promo.compre);
                  if (this.state.descontoExtra !== carrinhoItem.produto.precoDesconto * qtdDescontos) {
                    this.setState({
                      descontoExtra: carrinhoItem.produto.precoDesconto * qtdDescontos,
                    });
                  }
                }
              }
            }
          }
        }
      });
    }
  }

  componentDidUpdate(): any {
    const { tipoPagamento, numeroCartao } = this.state;
    if (tipoPagamento.length > 0 && numeroCartao.length === 0) {
      window.scrollTo(0, document.body.scrollHeight);
    }
  }

  getPaymentId(bandeira: string, tipoPgto: string): number {
    const meio:
      | C5MeioPagamentoModel
      | undefined = this.state.meiosPagamento.find(
      (mp: C5MeioPagamentoModel) =>
        mp.identificador === bandeira && tipoPgto === mp.tipo
    );

    if (meio) {
      return +meio.meioPagamentoId;
    } else {
      throw new Error("Erro ao identificar cartão.");
    }
  }

  getCartaoIcone(cartao: CartaoCreditoEnum): string {
    const baseCartaoLink: string = NavegadorUtil.getUrl(
      "/assets/images/icons/cards"
    );
    switch (cartao) {
      case CartaoCreditoEnum.VISA:
        return `${baseCartaoLink}/visa.svg`;
      case CartaoCreditoEnum.MASTERCARD:
        return `${baseCartaoLink}/mc.svg`;
      case CartaoCreditoEnum.ELO:
        return `${baseCartaoLink}/elo.svg`;
      case CartaoCreditoEnum.AMEX:
        return `${baseCartaoLink}/amex.svg`;
    }
    return "";
  }

  async setValue(campo: CampoFormularioEnum, valor: string): Promise<void> {
    const loja = AppState.getLojaSelecionada();

    if (loja) {
      switch (campo) {
        case CampoFormularioEnum.TIPO_PAGAMENTO:
          this.setState({ tipoPagamento: valor });
          break;
        case CampoFormularioEnum.NUMERO_CARTAO:
          const numeroCartao: string = valor.replace(/ /g, "").replace(/_/g, "");
          this.setState({ numeroCartao });
          if (numeroCartao.length === 16) {
            let bandeira: string = "";
            
            try {
              bandeira = await ProxyPagamentoDAO.getInstance().getCardBin(numeroCartao.replace(/ /g, '').substring(0, 6), +loja.lojaId);
            } catch (ex) {
              NavegadorUtil.alerta(this, ex.message);
              LogUtil.logEvento('PagamentoFalha', { numeroCartao, ex });
            }
  
            switch(bandeira) {
              case CartaoCreditoEnum.VISA:
                this.setState({
                  imagemCartao: this.getCartaoIcone(CartaoCreditoEnum.VISA),
                  bandeiraCartao: bandeira,
                  bandeiraCartaoClearsale: CartaoCreditoClearsaleEnum.VISA,
                });
                break;
              case CartaoCreditoEnum.MASTERCARD:
                this.setState({
                  imagemCartao: this.getCartaoIcone(
                    CartaoCreditoEnum.MASTERCARD
                  ),
                  bandeiraCartao: bandeira,
                  bandeiraCartaoClearsale: CartaoCreditoClearsaleEnum.MASTERCARD,
                });
                break;
              case CartaoCreditoEnum.ELO:
                this.setState({
                  imagemCartao: this.getCartaoIcone(CartaoCreditoEnum.ELO),
                  bandeiraCartao: bandeira,
                  bandeiraCartaoClearsale: CartaoCreditoClearsaleEnum.ELO,
                });
                break;
              case CartaoCreditoEnum.AMEX:
                this.setState({
                  imagemCartao: this.getCartaoIcone(CartaoCreditoEnum.AMEX),
                  bandeiraCartao: bandeira,
                  bandeiraCartaoClearsale: CartaoCreditoClearsaleEnum.AMEX,
                });
                break;
            }
          }
          break;
        case CampoFormularioEnum.NOME_CARTAO:
          this.setState({ nomeCartao: valor });
          break;
        case CampoFormularioEnum.CPF_TITULAR:
          this.setState({ cpfTitular: valor });
          break;
        case CampoFormularioEnum.VALIDADE:
          this.setState({ validade: valor });
          break;
        case CampoFormularioEnum.CODIGO_SEGURANCA:
          this.setState({ codigoSeguranca: valor });
          break;
      }
    }
  }

  validarCartaoBandeira(): boolean {
    try {
      this.getPaymentId(this.state.bandeiraCartao, this.state.tipoPagamento);
      return true;
    } catch (err) {
      NavegadorUtil.alerta(
        this,
        `No momento não aceitamos esta bandeira (${this.state.bandeiraCartao} - ${this.state.tipoPagamento}).`
      );
      return false;
    }
  }

  async pagar(): Promise<void> {
    const { bandeiraCartaoClearsale, descontoExtra } = this.state;
    this.setState({ pagando: true });
    const carrinho: CarrinhoModel = AppState.getCarrinho();
    const agendamento: AgendamentoRetiradaModel | null = AppState.getAgendamentoRetirada();
    let agendamentoCod: number = 0;
    const msg = AppState.getDescricaoEntrega();
    let msgRetirada: string = "";
    
    if (msg) {
      msgRetirada = msg;
    }
        
    let totalCompra: number = 0;
    for (const item of carrinho.carrinhoItens) {
      if (item.produto.unidade === "GR") {
        totalCompra +=
          ((item.quantidade * item.produto.precoDesconto) / 1000) *
          item.produto.fatorMultiplicacao;
      } else {
        totalCompra += item.quantidade * item.produto.precoDesconto;
      }
    }
    totalCompra = totalCompra - descontoExtra;

    if (agendamento) {
      agendamentoCod = +agendamento.agendamentoId;
    }

    const usuarioLogado: UsuarioModel | null = AppState.getUsuarioLogado();
    const loja: LojaModel | null = AppState.getLojaSelecionada();

    if (usuarioLogado && loja) {
      const { codigoSeguranca, cpfTitular, nomeCartao, numeroCartao, validade, formaPagamento } = this.state;

      if (formaPagamento === FormaPagamentoEnum.PAGAMENTO_ONLINE) {
        const objPagamentoCustomizado: C5PagamentoDetalhesModel = {
          PaymentID: 293,
          Installments: 1,
          PaymentAmount: totalCompra,
        } as C5PagamentoDetalhesModel;
  
        try {
          const endereco: UsuarioEnderecoModel | null = await C5UsuarioDAO.getInstance().buscaUsuarioEnderecoCompleto(
            +usuarioLogado.clienteId
          );
  
          if (endereco) {
            const CieloEndereco: CieloAddress = {
              City: endereco.cidadeEstado.indexOf('/') > -1 ? endereco.cidadeEstado.split('/')[0].trim() : endereco.cidadeEstado,
              Complement: endereco.complemento,
              Country: "BRA",
              Number: endereco.numero,
              State: endereco.estado,
              Street: endereco.endereco,
              ZipCode: endereco.cep.toString()
            } as CieloAddress;
    
            let bandeira: string = "";
            try {
              bandeira = await ProxyPagamentoDAO.getInstance().getCardBin(numeroCartao.replace(/ /g, '').substring(0, 6), +loja.lojaId);
            } catch (ex) {
              console.log({ex});
              NavegadorUtil.alerta(this, `Erro ao processar dados do cartão.  Favor revise o número, nome e vencimento.`);
              LogUtil.logEvento('PagamentoFalha', `Erro ao tentar obter bandeira do cartão informado [${numeroCartao.substring(0, 6)}]`);
              this.setState({ pagamentoSucesso: false });
              return;
            }

            const cieloCustomer: CieloCustomer = {
              Address: CieloEndereco,
              DeliveryAddress: CieloEndereco,
              Email: usuarioLogado.email,
              Name: usuarioLogado.nome,
              Birthdate: DataUtil.toUsDate(usuarioLogado.nascimento)
            } as CieloCustomer;
  
            const cieloOrder = Math.ceil(Math.random() * 10000000).toString();
            const cieloPagamentoObj: CieloPagamentoModel = {
              Amount: totalCompra,
              Capture: false,
              OrderNumber: cieloOrder,
              Customer: cieloCustomer,
              StoreId: loja.lojaId,
              CreditCard: {
                Brand: bandeira === CartaoCreditoEnum.MASTERCARD ? "MASTER" : bandeira,
                CVV: codigoSeguranca,
                CreditCardNumber: numeroCartao.replace(/ /g, ""),
                ExpirationMonth: validade.split("/")[0],
                ExpirationYear: `20${validade.split("/")[1]}`,
                HolderName: nomeCartao,
              } as CieloCreditCard,
            } as CieloPagamentoModel;
  
            let cieloPagamento: any;
  
            try {
              cieloPagamento = await ProxyPagamentoDAO.getInstance().postPayment(cieloPagamentoObj);
            } catch (ex) {
              let messages = "";
              if (ex && ex.response && ex.response.data && ex.response.data.data && ex.response.data.data.length > 0) {
                messages = ex.response.data.data.map((d:any) => d.message);
              }
              console.log({ messages, ex });
              NavegadorUtil.alerta(this, `Erro ao processar pagamento online. [${messages.toString()}]`);
              LogUtil.logEvento('PagamentoFalha', ex);
              this.setState({ pagando: false, })
              return;
            }
  
  
            if (cieloPagamento && (+cieloPagamento.data.payment.status === 1 || +cieloPagamento.data.payment.status === 2)) {
              LogUtil.logEvento('PagamentoSucesso', cieloPagamento);
              let CSSession = document.getElementById('CSSession');
              let clearsaleSessionID = "";
              if (CSSession) {
                clearsaleSessionID = (CSSession as any).value;
              }
  
              let publicIP = "";
              try {
                publicIP = await publicIp.v4();
              } catch(ex) {
                LogUtil.logEvento('ErroObterIP', ex);
              }
  
              const clearsaleTelefone = {
                type: 0,
                ddi: 55,
                ddd: +usuarioLogado.telefone.substring(0,2),
                number: +usuarioLogado.telefone.substring(2),
                extension: "",
              } as ClearsaleTelefoneModel;
  
              const clearsaleEndereco = {
                street: CieloEndereco.Street,
                number: CieloEndereco.Number,
                additionalInformation: CieloEndereco.Complement,
                state: CieloEndereco.State,
                city: CieloEndereco.City,
                zipcode: CieloEndereco.ZipCode,
                county: endereco.bairro,
                country: "Brasil",
                reference: "",
              } as ClearsaleEnderecoModel;
  
              const clearsaleEnderecoLoja = {
                street: loja.logradouro,
                number: loja.numero,
                additionalInformation: loja.complemento,
                state: loja.uf,
                city: loja.cidade,
                zipcode: loja.cepDelivery,
                county: loja.cidade,
                country: "Brasil",
                reference: "",
              } as ClearsaleEnderecoModel;
  
              let maskedCard = numeroCartao.replace(/ /g, '').substring(0, 6) +
                numeroCartao.substr(numeroCartao.length - 4, 4).padStart(numeroCartao.length - 10, 'x');
  
              const clearsaleCartao = {
                number: maskedCard,
                hash: cieloPagamento.data.payment.creditCard.cardToken,
                bin: numeroCartao.replace(/ /g, '').substring(0, 6),
                end: numeroCartao.substr(numeroCartao.length - 4, 4),
                type: bandeiraCartaoClearsale,
                document: cpfTitular,
                nsu: cieloPagamento.data.payment.proofOfSale,
                ownerName: nomeCartao,
                validityDate: validade,
              } as ClearsaleCardModel;
  
              const phones = [];
              phones.push(clearsaleTelefone);
  
              const clearsaleBilling = {
                clientID: usuarioLogado.clienteId.toString(),
                type: 1,
                primaryDocument: usuarioLogado.documento,
                name: usuarioLogado.nome,
                birthDate: DataUtil.toUsDate(usuarioLogado.nascimento),
                email: usuarioLogado.email,
                gender: usuarioLogado.sexo,
                address: clearsaleEndereco,
                phones,
              } as ClearsaleBillingModel;
  
              const msgEntrega = AppState.getDescricaoEntrega();
              let tipoDelivery = "16";
              if (msgEntrega && (msgEntrega.indexOf('entrega') > -1)) {
                tipoDelivery = "12";
              }
  
              const clearsaleShipping = {
                clientID: usuarioLogado.clienteId.toString(),
                type: 1,
                primaryDocument: usuarioLogado.documento,
                name: usuarioLogado.nome,
                birthDate: DataUtil.toUsDate(usuarioLogado.nascimento),
                email: usuarioLogado.email,
                gender: usuarioLogado.sexo,
                address: tipoDelivery === "16" ? clearsaleEnderecoLoja : clearsaleEndereco,
                phones,
                deliveryType: tipoDelivery,
                price: 0,
                pickUpStoreDocument: tipoDelivery === "16" ? usuarioLogado.documento : "",
              } as ClearsaleShippingModel;
              
              const clearsalePayment = {
                currency: 986,
                installments: 1,
                interestRate: 0,
                interestValue: 0,
                type: 1,
                value: totalCompra,
                address: clearsaleEndereco,
                card: clearsaleCartao,
              } as ClearsalePagamentoItemModel;
  
              const clearsalePagamento = {
                code: cieloOrder.toString(),
                sessionID: clearsaleSessionID,
                date: new Date(),
                email: usuarioLogado.email,
                b2bB2c: "B2C",
                itemValue: totalCompra,
                totalValue: totalCompra,
                numberOfInstallments: 1,
                ip: publicIP,
                isGift: false,
                giftMessage: "",
                observation: AppState.getProdutoAlternativo(),
                status: 0,
                origin: "webapp",
                channelID: "mobile",
                reservationDate: new Date().toISOString(),
                country: "Brasil",
                nationality: "Brasileiro",
                product: 4,
                customSla: 120,
                billing: clearsaleBilling,
                shipping: clearsaleShipping,
                payments: [ clearsalePayment ], 
                items: ClearsaleItemModel.toModel(carrinho.carrinhoItens),
              } as ClearsalePagamentoModel;
  
              let antifraude: any = null;
              
              try {
                antifraude = await ProxyPagamentoDAO.getInstance().postClearsale(clearsalePagamento);
              } catch (ex) {
                LogUtil.logEvento('AntifraudeFalha', ex);
              }
    
              LogUtil.logEvento('AntifraudeSucesso', antifraude);
  
              if (!antifraude) {
                const pagamento: C5PagamentoModel = {
                  ClientID: +usuarioLogado.clienteId,
                  ClientAddressID: +usuarioLogado.clienteEnderecoId,
                  CustomPayment: false,
                  FreightWithdrawalOption: null,
                  LocalPayment: true,
                  Notes: AppState.getProdutoAlternativo(),
                  SalesChannelID: +loja.lojaId,
                  SaleIdRetry: 0,
                  SaleOriginType: 1,
                  ScheduleID: agendamentoCod,
                  ShipId: AppState.getFreteTipoId(),
                  UIDBasket: carrinho.carrinhoId,
                  Payments: [ objPagamentoCustomizado ],
                } as C5PagamentoModel;
        
                LogUtil.logCompra(pagamento);

                const primeiroCarrinhoItem = carrinho.carrinhoItens[0];
                primeiroCarrinhoItem.notas += "** PEDIDO COM PAGAMENTO ONLINE **";
                await AppState.setCarrinhoItemNota(carrinho.carrinhoItens[0].produto.produtoId, primeiroCarrinhoItem.notas);

                C5PagamentoDAO.getInstance()
                  .pagar(pagamento)
                  .then((r: any) => {
                    if (r.data.Code.toString() !== "200") {
                      NavegadorUtil.alerta(this, r.data.Message);
                      LogUtil.logEvento('PagamentoOnlineErro', r);
                      this.setState({ pagando: false });
                    } else {
                      LogUtil.logEvento('PagamentoOnlineSucesso', r);

                      cieloPagamento.cardBin = numeroCartao.replace(/ /g, '').substring(0, 6);
                      cieloPagamento.codigoBandeira = bandeira;
                      cieloPagamento.last4 = numeroCartao.substr(numeroCartao.length - 4, 4);
                      cieloPagamento.holderName = nomeCartao;
                      cieloPagamento.expiration = validade;
    
                      ProxyCacheDAO.getInstance()
                        .postCompraDetalhes(pagamento, msgRetirada, r.data.SaleID, 
                          cieloPagamento, totalCompra, codigoSeguranca,
                          cieloCustomer, undefined, undefined)
                        .then(async () => {

                          try {
                            await ProxyEsqueciSenhaDAO.getInstance()
                              .postNPS(usuarioLogado.email);
                            await ObaPedidoDAO.getInstance().postStoreApp(r.data.SaleID);
                          } catch (ex) { }
  
                          LogUtil.logPage("Efetivou a compra");
        
                          AppState.limparCarrinho();
                          window.scrollTo(0, 0);
                          this.setState({ pagando: false });
                          this.setState({ pagamentoSucesso: true });
                        })
                        .catch((e) => {
                          LogUtil.logObject(e, typeof e);
                          LogUtil.logEvento('PagamentoFalha', e);
                          this.setState({ pagamentoSucesso: false });
                        });
                    }
                  }).catch(err => {
                    LogUtil.logEvento('PagamentoFalha', err);
                    this.setState({ pagamentoSucesso: false });
                    return;
                  });
    
              } else {
                this.setState({pagando: false});
              }
            } else {
              LogUtil.logEvento('PagamentoFalha', cieloPagamento);
              if (cieloPagamento && cieloPagamento.data && cieloPagamento.data.payment) {
                NavegadorUtil.alerta(this, `Erro ao processar pagamento [${cieloPagamento.data.payment.returnMessage}]`)
              }
              this.setState({ pagando: false, })
              return;
            }
          }
        } catch (err) {
          NavegadorUtil.alerta(this, err.message);
          this.setState({ pagando: false, pagamentoSucesso: false });
        }
      }

      if (formaPagamento === FormaPagamentoEnum.PAGAMENTO_NA_RETIRADA) {
        const objPagamentoRetirada: C5PagamentoDetalhesModel = {
          PaymentID: 292,
          Installments: 1,
          PaymentAmount: totalCompra,
        } as C5PagamentoDetalhesModel;
  
        try {
          const pagamento: C5PagamentoModel = {
            ClientID: +usuarioLogado.clienteId,
            ClientAddressID: +usuarioLogado.clienteEnderecoId,
            CustomPayment: false,
            FreightWithdrawalOption: null,
            LocalPayment: true,
            Notes: AppState.getProdutoAlternativo(),
            SalesChannelID: +loja.lojaId,
            SaleIdRetry: 0,
            SaleOriginType: 1,
            ScheduleID: agendamentoCod,
            ShipId: AppState.getFreteTipoId(),
            UIDBasket: carrinho.carrinhoId,
            Payments: [objPagamentoRetirada],
          } as C5PagamentoModel;
  
          const primeiroCarrinhoItem = carrinho.carrinhoItens[0];
          primeiroCarrinhoItem.notas += "** PEDIDO COM PAGAMENTO NA ENTREGA/RETIRADA **";
          await AppState.setCarrinhoItemNota(carrinho.carrinhoItens[0].produto.produtoId, primeiroCarrinhoItem.notas);

          C5PagamentoDAO.getInstance()
            .pagar(pagamento)
            .then(async (r: any) => {
              if (r.data.Code.toString() === "500") {
                NavegadorUtil.alerta(this, r.data.Message);
                this.setState({ pagando: false });
              } else {
                LogUtil.logCompra(pagamento);

                const end = await C5UsuarioDAO.getInstance().buscaUsuarioEnderecoCompleto(+usuarioLogado.clienteId);

                if (end) {
                  ProxyCacheDAO.getInstance()
                    .postCompraDetalhes(pagamento, msgRetirada, r.data.SaleID, undefined, undefined, undefined, undefined,  usuarioLogado, end)
                    .then(async () => {
                      await ProxyEsqueciSenhaDAO.getInstance()
                        .postNPS(usuarioLogado.email);
                
                      try {
                        await ObaPedidoDAO.getInstance().postStoreApp(r.data.SaleID);
                      } catch (ex) {
                        LogUtil.log(ex);
                      }
                        
                      LogUtil.logPage("Efetivou a compra");
  
                      AppState.limparCarrinho();
                      window.scrollTo(0, 0);
                      this.setState({ pagando: false });
                      this.setState({ pagamentoSucesso: true });
                    })
                    .catch((e) => {
                      LogUtil.logObject(e, typeof e);
                      this.setState({ pagamentoSucesso: false });
                    });
                }
              }
          });
        } catch (err) {
          LogUtil.logEvento('PagamentoFalha', err);
          NavegadorUtil.alerta(this, err.message);
          this.setState({ pagando: false, pagamentoSucesso: false });
        }
      }
    } else {
      NavegadorUtil.redirect("/login", this.props.history);
    }
  }

  setCartao(tipoPagamento: string): void {
    this.setState({ tipoPagamento, numeroCartao: "" });
  }

  setPagamentoRetirada(): void {
    this.setState({ formaPagamento: FormaPagamentoEnum.PAGAMENTO_NA_RETIRADA });
  }

  setPagamentoOnline(): void {
    this.setState({ formaPagamento: FormaPagamentoEnum.PAGAMENTO_ONLINE });
  }

  render(): any {
    const fieldWidth: number = 300;
    const objStyle: any = {
      width: fieldWidth,
      margin: "0 auto",
      display: "block",
      marginTop: 30,
    };
    let mensagemRetirada: string = "";
    const objRetirada: AgendamentoRetiradaModel | null = AppState.getAgendamentoRetirada();

    if (objRetirada) {
      mensagemRetirada = objRetirada.titulo;
    }

    let msgRetirada: string | null = AppState.getDescricaoEntrega();

    if (!msgRetirada) {
      msgRetirada = "Agendamento de retirada";
    }

    const {
      bandeiraCartao,
      tipoPagamento,
      pagamentoSucesso,
      pagando,
      numeroCartao,
      nomeCartao,
      cpfTitular,
      validade,
      codigoSeguranca,
      creditoHabilitado,
      formaPagamento,
      formasPagamento,
    } = this.state;

    if (pagamentoSucesso) {
      NavegadorUtil.redirect("/pedidos", this.props.history);
    }

    let alerta: any = AppState.getAlerta();
    if (!alerta) {
      alerta = {
        exibirModal: false,
      } as AlertaModel;
    }

    const loja: LojaModel | null = AppState.getLojaSelecionada();
    if (loja) {
      return (
        <section className="lists payment white-bg">
          <div className="header">
            <BotaoVoltar titulo="Forma de pagamento"></BotaoVoltar>
          </div>
          <div className="store-pickup">
            <p className="title">Loja:</p>
            <p>
              {loja.nome} - {loja.logradouro}, {loja.numero} - {loja.bairro},{" "}
              {loja.cidade} - {loja.uf}, {loja.cep}
            </p>
            <br />
            <p className="title">Caso o produto não esteja disponível:</p>
            <p>{AppState.getProdutoAlternativo()}</p>
            <br />
            <p className="title">{msgRetirada}:</p>
            <p>{mensagemRetirada}</p>
          </div>
          <div className="cards paymentDelivery">
          { formasPagamento.some(fp => fp === FormaPagamentoEnum.PAGAMENTO_NA_RETIRADA) &&
            <>
              <div onClick={this.setPagamentoRetirada}>
                {AppState.getMetodoEntrega() === "delivery" && (
                  <>Pagamento na entrega</>
                )}
                {AppState.getMetodoEntrega() === "retirada" && (
                  <>
                    <p><b>Pagamento na retirada</b></p>
                    <p>O pagamento será feito na retirada com as mesmas opções da loja.</p>
                    
                  </>
                )}
              </div>
            </>
          }
          { formasPagamento.some(fp => fp === FormaPagamentoEnum.PAGAMENTO_ONLINE) &&
            <div onClick={this.setPagamentoOnline}>
              Pagamento online <em style={{ color: "#fafafa" }}></em>
            </div>
          }
          { formaPagamento === FormaPagamentoEnum.PAGAMENTO_NA_RETIRADA &&
            <>
              {pagando && (
                <button className="main-button inactive">
                  Processando pedido
                </button>
              )}
              {!pagando && (
                <button className="main-button inactive" onClick={this.pagar}>
                  Confirmar pedido
                </button>
              )}
              <br/><br/>
              <div><b>Atenção:</b> Os valores e condições dos produtos da cesta de compras corresponderão aos mesmos atribuídos no ato do pedido, independentemente do dia da retirada/pagamento.</div>
            </>
          }
          </div>
          <div className="cards">
            {creditoHabilitado && (
              <div
                onClick={() => this.setCartao("CRD")}
                className={tipoPagamento === "CRD" ? "active" : ""}
              >
                <div>Cartão de crédito</div>
                <div className="flags">
                  <img
                    src={this.getCartaoIcone(CartaoCreditoEnum.VISA)}
                    alt="Bandeira"
                  />
                  <img
                    src={this.getCartaoIcone(CartaoCreditoEnum.MASTERCARD)}
                    alt="Bandeira"
                  />
                  <img
                    src={this.getCartaoIcone(CartaoCreditoEnum.ELO)}
                    alt="Bandeira"
                  />
                  <img
                    src={this.getCartaoIcone(CartaoCreditoEnum.AMEX)}
                    alt="Bandeira"
                  />
                </div>
              </div>
            )}
          </div>
          {(formaPagamento === FormaPagamentoEnum.PAGAMENTO_ONLINE) && (
            <div className="hours">
              <h2>Digite os dados de seu cartão</h2>
              {bandeiraCartao !== "amex" && (
                <FormControl
                  variant="outlined"
                  style={objStyle}
                  className="field-icon"
                >
                  <InputMask
                    mask="9999 9999 9999 9999"
                    maskChar="_"
                    value={numeroCartao}
                    onChange={(e) =>
                      this.setValue(
                        CampoFormularioEnum.NUMERO_CARTAO,
                        e.target.value as string
                      )
                    }
                  >
                    {(inputProps: any) => (
                      <ObaTextField
                        {...inputProps}
                        style={{ width: fieldWidth - 60 }}
                        variant="outlined"
                        label={
                          tipoPagamento === "DEB"
                            ? "Número do cartão de débito"
                            : "Número do cartão de crédito"
                        }
                      ></ObaTextField>
                    )}
                  </InputMask>
                  {this.state.imagemCartao && (
                    <img src={this.state.imagemCartao} alt="Bandeira" />
                  )}
                </FormControl>
              )}
              {bandeiraCartao === "amex" && (
                <FormControl
                  variant="outlined"
                  style={objStyle}
                  className="field-icon"
                >
                  <InputMask
                    mask="9999 999999 99999"
                    maskChar="_"
                    value={numeroCartao}
                    onChange={(e) =>
                      this.setValue(
                        CampoFormularioEnum.NUMERO_CARTAO,
                        e.target.value as string
                      )
                    }
                  >
                    {(inputProps: any) => (
                      <ObaTextField
                        {...inputProps}
                        style={{ width: fieldWidth - 60 }}
                        variant="outlined"
                        label="Número do cartão de crédito"
                      ></ObaTextField>
                    )}
                  </InputMask>
                </FormControl>
              )}
              <FormControl variant="outlined" style={objStyle}>
                <ObaTextField
                  onChange={(e) =>
                    this.setValue(
                      CampoFormularioEnum.NOME_CARTAO,
                      e.target.value as string
                    )
                  }
                  style={{ width: fieldWidth }}
                  variant="outlined"
                  label="Nome impresso no cartão"
                  value={nomeCartao}
                />
              </FormControl>
              <FormControl variant="outlined" style={objStyle}>
                <InputMask
                  mask="999.999.999-99"
                  maskChar="_"
                  value={cpfTitular}
                  onChange={(e) =>
                    this.setValue(
                      CampoFormularioEnum.CPF_TITULAR,
                      e.target.value as string
                    )
                  }
                >
                  {(inputProps: any) => (
                    <ObaTextField
                      {...inputProps}
                      style={{ width: fieldWidth }}
                      variant="outlined"
                      label="CPF do titular"
                    ></ObaTextField>
                  )}
                </InputMask>
              </FormControl>
              <FormControl variant="outlined" style={objStyle}>
                <InputMask
                  mask="99/99"
                  maskChar="_"
                  value={validade}
                  onChange={(e) =>
                    this.setValue(
                      CampoFormularioEnum.VALIDADE,
                      e.target.value as string
                    )
                  }
                >
                  {(inputProps: any) => (
                    <ObaTextField
                      {...inputProps}
                      style={{ width: fieldWidth }}
                      variant="outlined"
                      label="Validade (mm/aa)"
                    ></ObaTextField>
                  )}
                </InputMask>
              </FormControl>
              {bandeiraCartao === "amex" && (
                <FormControl
                  variant="outlined"
                  style={objStyle}
                  className="field-icon"
                >
                  <InputMask
                    mask="9999"
                    maskChar="_"
                    value={codigoSeguranca}
                    onChange={(e) =>
                      this.setValue(
                        CampoFormularioEnum.CODIGO_SEGURANCA,
                        e.target.value as string
                      )
                    }
                  >
                    {(inputProps: any) => (
                      <ObaTextField
                        {...inputProps}
                        style={{ width: fieldWidth - 60 }}
                        variant="outlined"
                        label="Código de Segurança"
                      ></ObaTextField>
                    )}
                  </InputMask>
                  <img
                    src={NavegadorUtil.getUrl(
                      "/assets/images/icons/cards/cvv.svg"
                    )}
                    alt="Código de segurança"
                    title="Código de segurança"
                  />
                </FormControl>
              )}
              {bandeiraCartao !== "amex" && (
                <FormControl
                  variant="outlined"
                  style={objStyle}
                  className="field-icon"
                >
                  <InputMask
                    mask="999"
                    maskChar="_"
                    value={codigoSeguranca}
                    onChange={(e) =>
                      this.setValue(
                        CampoFormularioEnum.CODIGO_SEGURANCA,
                        e.target.value as string
                      )
                    }
                  >
                    {(inputProps: any) => (
                      <ObaTextField
                        {...inputProps}
                        style={{ width: fieldWidth - 60 }}
                        variant="outlined"
                        label="Código de Segurança"
                      ></ObaTextField>
                    )}
                  </InputMask>
                  <img
                    src={NavegadorUtil.getUrl(
                      "/assets/images/icons/cards/cvv.svg"
                    )}
                    alt="Código de segurança"
                    title="Código de segurança"
                  />
                </FormControl>
              )}
              {pagando && (
                <button className="main-button inactive">
                  Processando pedido
                </button>
              )}
              {!pagando && (
                <button className="main-button inactive" onClick={this.pagar}>
                  Confirmar &nbsp;pedido
                </button>
              )}
            </div>
          )}
          <Snackbar
            open={alerta.exibirModal}
            className="info"
            transitionDuration={1000}
            onClose={() => AppState.fecharAlerta(this)}
            autoHideDuration={6000}
            ContentProps={{
              "aria-describedby": "message-id",
            }}
            message={<span id="message-id">{alerta.mensagem}</span>}
          />
        </section>
      );
    }
  }
}

export default withRouter(FormaPagamento);
